"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolioService = void 0;
class FolioService {
    constructor($q, $http, $rootScope, uploadService, toolbox) {
        this.$q = $q;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.uploadService = uploadService;
        this.toolbox = toolbox;
        this.baseUrl = 'Api/Folio';
    }
    upload(file) {
        const uri = this.baseUrl; // + '/'
        return this.uploadService.upload(uri, 'PUT', file)
            .then(response => response.data);
    }
    parseICFromDocumentName(documentName) {
        // M-1412-5311: unescape to avoid double encoding
        documentName = window['unescape'](documentName);
        const uri = `${this.baseUrl}/ics?documentName=${encodeURIComponent(documentName)}`;
        return this.$http.get(uri)
            .then(response => response.data);
    }
}
exports.FolioService = FolioService;
FolioService.$inject = ['$q', '$http', '$rootScope', 'uploadService', 'toolbox'];
